<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="查看会员"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-form-item label="头像">
				<img :src="item.avatar">
			</el-form-item>
			<el-form-item label="昵称">
				<el-input v-model="item.nick_name" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="积分">
				<el-input v-model="item.jifen" placeholder="请输入积分"></el-input>
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input v-model="item.mobile" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="性别">
				<el-input v-model="item.sexy" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="会员等级">
				<el-input v-model="item.level" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-input v-model="item.type" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="所属店铺">
				<el-input v-model="item.store" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="创建时间">
				<el-input v-model="item.created_date" placeholder="请输入内容"></el-input>
			</el-form-item>
			<el-form-item label="最后登录时间">
				<el-input v-model="item.last_modified_date" placeholder="请输入内容"></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ''
				// 获取数据
				res = await this.axios.get('/admin/member/detail', {
					params:{
						id: this.id
					}
				})
				console.log(res);
				// 获取数据
				this.item = res.data.detail
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
		}
	}
</script>
<style scoped>
</style>
